export const FETCH_CARDS_RATES_REQUEST = 'FETCH_CARDS_RATES_REQUEST';
export const FETCH_CARDS_RATES_SUCCESS = 'FETCH_CARDS_RATES_SUCCESS';
export const FETCH_CARDS_RATES_FAILURE = 'FETCH_CARDS_RATES_FAILURE';
